import { Box, styled } from "@mui/material";
import { theme } from "../../../../theme";

export const SubtypePreviewContainer = styled(Box)((props: {
    selected: boolean,
    opacity: number,
}) => ({
    userSelect: "none",
    borderWidth: "0.5px",
    borderStyle: "solid",
    borderRadius: "0.5rem",
    borderColor: props.selected ? theme.palette.border.subform : "transparent",
    opacity: props.opacity,
    cursor: "pointer",
    padding: "0.5rem",
}));